/**
 * Pure grouping of Slack attention items by channel or linked ticket.
 */

import { AttentionItem } from './types';

export type SlackGroupingMode = 'flat' | 'channel' | 'task';

export interface SlackThreadGroup {
  key: string;
  label: string;
  items: AttentionItem[];
}

export function groupSlackItems(
  items: AttentionItem[],
  mode: SlackGroupingMode
): SlackThreadGroup[] {
  if (mode === 'flat') {
    return [{ key: 'flat', label: '', items }];
  }

  const buckets = new Map<string, AttentionItem[]>();

  items.forEach((item) => {
    const key = mode === 'channel' ? item.primary || 'Sin canal' : item.ticket || 'Sin ticket';
    const current = buckets.get(key) || [];
    current.push(item);
    buckets.set(key, current);
  });

  return Array.from(buckets.entries()).map(([key, grouped]) => ({
    key,
    label: mode === 'channel' ? key : key === 'Sin ticket' ? 'Sin ticket vinculado' : key,
    items: grouped,
  }));
}
